import { useMemo, useState } from 'react';

import { useLocation, useParams } from 'react-router';

import { getStreamMuted } from './lib/getStreamMuted';
import type { PlayerStatus } from './model/useGameStreamPlayer';
import { GameStreamVideo } from './ui/GameStreamVideo';

export function GameStream() {
  const { gameId } = useParams();
  const { search } = useLocation();
  const [status, setStatus] = useState<PlayerStatus>('initialized');
  const streamMuted = getStreamMuted(search);
  const streamName = gameId || '';
  const statusText = useMemo(() => {
    switch (status) {
      case 'initialized':
        return 'Инициализация плеера...';
      case 'connecting':
        return 'Подключение к трансляции...';
      case 'paused':
        return 'Трансляция на паузе';
      case 'stopped':
        return 'Трансляция остановлена';
      case 'playing':
      default:
        return null;
    }
  }, [status]);

  return (
    <div className="min-w-screen min-h-screen relative">
      {statusText && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-black/60 text-white text-2xl font-semibold pointer-events-none">
          {statusText}
        </div>
      )}
      <GameStreamVideo muted={streamMuted} onStatusChange={setStatus} streamName={streamName} whepUrl={import.meta.env.VITE_WHEP_URL} />
    </div>
  );
}
